import * as actionTypes from '../../actions/BUAP/actionsTypes';

const inititalState = {
    allowtoreg: '',
};

const studentDegreeReducer = (state = inititalState, action) => {
    switch (action.type) {
        case actionTypes.SETALLOWREG:
            return {
                ...state,
                allowtoreg: action.value
            }
        default:
            return state;
    }
}

export default studentDegreeReducer;